<template>
	<div class="content">
		<div class="title">
			<span>专题学习 / </span>
			<span>{{detail.courseName}}</span>
		</div>
		<div class="content_con">
			<div class="title_kcjs">
				课程介绍
			</div>
			<div class="con_kcjs">
				<img class="con_kcjs_img" :src="detail.imgUrl"/>
				<div>
					<div class="con_kcjs_title">{{detail.courseName}}</div>
					<!-- <div class="con_kcjs_div">学时：{{detail.classHour}}</div> -->
					<div class="con_kcjs_div">学时：{{detail.credit}}</div>
					<div class="con_kcjs_div">截止日期：{{detail.deadline}}</div>
					<div class="con_kcjs_div">价格：
						<span class="con_kcjs_price">{{ detail.price }}</span>
					</div>
					<div class="con_kcjs_btn" :style="{background:(detail.isPurchase == 0?'#858585':'')}" @click="addClass">
						{{detail.isPurchase == 0 ? '已选课' : '+ 选课'}}
					</div>
				</div>
			</div>
			<div v-if="detail.courseDesc">
				<div class="title_ztjs">
				专题介绍
				</div>
				<div class="con_ztjs">
					{{detail.courseDesc}}
				</div>
			</div>
			<div v-if="detail.teachers && detail.teachers.length>0">
				<div class="title_ztjs">
					老师介绍
				</div>
				<div class="con_lsjs">
					<div style="width: 6.24rem;display: flex;align-items: center;overflow-x: auto;">
						<div v-for="(item,key) in detail.teachers" :key="key">
							<div class="con_lsjs_left" @click="chooseTeacher(item)">
								<img class="con_lsjs_img" v-if="item.avatar" :src="item.avatar"/>
								<img class="con_lsjs_img" v-else src="../assets/class/headdemo.png"/>
								<div :class="teacher.id == item.id ? 'con_lsjs_text_act' : ''">
									{{item.realName}}
								</div>
							</div>
						</div>
					</div>
					<div class="con_lsjs_line"></div>
					<div class="con_lsjs_right">
						{{teacher.brief}}
					</div>
				</div>
			</div>
			<div class="title_ztnr" v-if="(videoList.resourcesName && videoList.resourcesName.length > 0) || (audioList.resourcesName && audioList.resourcesName.length > 0) || (imageList.resourcesName && imageList.resourcesName.length > 0) || (textList.resourcesName && textList.resourcesName.length > 0)">
				专题内容
			</div>
			<div v-if="videoList.resourcesName && videoList.resourcesName.length > 0">
				<div class="div_kcbiaoti">
					<div class="num_kcbiaoti">
						{{ getIndex(1) }}
					</div>
					<div class="text_kcbiaoti">
						视频课程<span class="text_span">（共{{videoList.number}}节）</span>
					</div>
				</div>
				<template>
					<div v-for="(item,key) in videoList.resourcesName" :key="key">
						<div class="con_kc">
							<div class="con_kc_left">
								<img class="con_kc_img" src="../assets/class/icon_shiping.png"/>
								<div>
									<div class="con_kc_zj">
										{{type == '1' ? item.gsrName : item.resourceName}}
									</div>
									<div class="con_kc_sc">
										{{type == '1' ? getTime(item.duration) : getTime(item.resourceTimeLength)}}
									</div>
									<div class="con_kc_progress">
										<div class="con_kc_progress_track">
											<div class="con_kc_progress_bar" :style="{ width: getWatchProgress(item) + '%' }"></div>
										</div>
										<span class="con_kc_progress_text">已观看 {{ getWatchProgress(item) }}%</span>
									</div>
								</div>
							</div>
							<div class="con_kc_btn" @click="goBoFang(item,1)">
								点击观看
							</div>
						</div>
						<div v-if="key+1 < videoList.resourcesName.length" class="con_kc_line"></div>
					</div>
				</template>
			</div>
			<div v-if="audioList.resourcesName && audioList.resourcesName.length > 0">
				<div class="div_kcbiaoti div_kcbiaoti_margin">
					<div class="num_kcbiaoti">
						{{ getIndex(2) }}
					</div>
					<div class="text_kcbiaoti">
						音频课程<span class="text_span">（共{{audioList.number}}节）</span>
					</div>
				</div>
				<template >
					<div v-for="(item,key) in audioList.resourcesName" :key="key">
						<div class="con_kc">
							<div class="con_kc_left">
								<img class="con_kc_img" src="../assets/class/icon_yinping.png"/>
								<div>
									<div class="con_kc_zj">
										{{type == '1' ? item.gsrName : item.resourceName}}
									</div>
									<div class="con_kc_sc">
										{{type == '1' ? getTime(item.duration) : getTime(item.resourceTimeLength)}}
									</div>
									<div class="con_kc_progress">
										<div class="con_kc_progress_track">
											<div class="con_kc_progress_bar" :style="{ width: getWatchProgress(item) + '%' }"></div>
										</div>
										<span class="con_kc_progress_text">已观看 {{ getWatchProgress(item) }}%</span>
									</div>
								</div>
							</div>
							<div class="con_kc_btn" @click="goBoFang(item,2)">
								点击观看
							</div>
						</div>
						<div v-if="key+1 < audioList.resourcesName.length" class="con_kc_line"></div>
					</div>
				</template>
			</div>
			<div v-if="imageList.resourcesName && imageList.resourcesName.length > 0">
				<div class="div_kcbiaoti div_kcbiaoti_margin">
					<div class="num_kcbiaoti">
						{{ getIndex(3) }}
					</div>
					<div class="text_kcbiaoti">
						图文课程<span class="text_span">（共{{imageList.number}}节）</span>
					</div>
				</div>
				<template>
					<div v-for="(item,key) in imageList.resourcesName" :key="key">
						<div class="con_kc">
							<div class="con_kc_left">
								<img class="con_kc_img" src="../assets/class/icon_tupian.png"/>
								<div>
									<div class="con_kc_zj">
										{{type == '1' ? item.gsrName : item.resourceName}}
									</div>
									<div class="con_kc_sc">
										{{type == '1' ? item.duration : item.resourceTimeLength}}MB
									</div>
								</div>
							</div>
							<div class="con_kc_btn" @click="goDownload(item)">
								点击下载
							</div>
						</div>
						<div v-if="key+1 < imageList.resourcesName" class="con_kc_line"></div>
					</div>
				</template>
			</div>
			<div v-if="textList.resourcesName && textList.resourcesName.length > 0">
				<div class="div_kcbiaoti div_kcbiaoti_margin">
					<div class="num_kcbiaoti">
						{{ getIndex(4) }}
					</div>
					<div class="text_kcbiaoti">
						文档课程<span class="text_span">（共{{textList.number}}节）</span>
					</div>
				</div>
				<template >
					<div v-for="(item,key) in textList.resourcesName" :key="key">
						<div class="con_kc">
							<div class="con_kc_left">
								<img class="con_kc_img" src="../assets/class/icon_kejian.png"/>
								<div>
									<div class="con_kc_zj">
										{{type == '1' ? item.gsrName : item.resourceName}}
									</div>
									<div class="con_kc_sc">
										{{type == '1' ? item.duration : item.resourceTimeLength}}MB
									</div>
								</div>
							</div>
							<div class="con_kc_btn" @click="goDownload(item)">
								点击下载
							</div>
						</div>
						<div v-if="key+1 < textList.resourcesName" class="con_kc_line"></div>
					</div>
				</template>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: "",
		data() {
			return {
				id:'',
				type: '', //1 专题  2 课程
				userInfo:'',
				detail:'',//详情
				hasLogin: false,
				videoList: {},
				audioList: {},
				imageList: {},
				textList: {},
				teacher: '',//选中的老师
			};
		},
		components: {},
		created() {
			this.userInfo = JSON.parse(sessionStorage.getItem('userInfo'));
			if(this.userInfo != null && this.userInfo != undefined){
				this.hasLogin = true;
			}
			this.id = this.$route.query.id;
			this.type = this.$route.query.type;
			this.getDetail();
		},
		methods:{
			getIndex(value){
				if(value === 1){
					if(this.videoList.resourcesName && this.videoList.resourcesName.length > 0){
						return 1
					}
				}else if(value === 2){
					if(this.videoList.resourcesName && this.videoList.resourcesName.length > 0){
						return 2
					}else{
						return 1
					}
				}else if(value === 3){
					if(this.videoList.resourcesName && this.videoList.resourcesName.length > 0){
						if(this.audioList.resourcesName && this.audioList.resourcesName.length > 0){
							return 3
						}else {
							return 2
						}
					}else{
						if(this.audioList.resourcesName && this.audioList.resourcesName.length > 0){
							return 2
						}else {
							return 1
						}
					}
				}else if(value === 4){
					if(this.videoList.resourcesName && this.videoList.resourcesName.length > 0){
						if(this.audioList.resourcesName && this.audioList.resourcesName.length > 0){
							if(this.imageList.resourcesName && this.imageList.resourcesName.length > 0){
								return 4
							}else{
								return 3
							}
						}else {
							if(this.imageList.resourcesName && this.imageList.resourcesName.length > 0){
								return 3
							}else{
								return 2
							}
						}
					}else{
						if(this.audioList.resourcesName && this.audioList.resourcesName.length > 0){
							if(this.imageList.resourcesName && this.imageList.resourcesName.length > 0){
								return 3
							}else{
								return 2
							}
						}else {
							if(this.imageList.resourcesName && this.imageList.resourcesName.length > 0){
								return 2
							}else{
								return 1
							}
						}
					}
				}
			},
			//查询课程详情
			getDetail(){
				let url = this.type == '1' ? '/blade-web/learn-subject/get-subject-info/' : '/user/CourseClassUserInfo/courseInfo/';
				
				this.$get(url + this.id, {})
					.then((res) => {
						console.log('详情',res);
						if (res.code == '200') {
							this.detail = res.data;
							if(this.detail.teachers && this.detail.teachers.length > 0){
								this.teacher = this.detail.teachers[0];
							}
							let img;
							if(this.type == '1'){
								img = JSON.parse(this.detail.coverAddress)[0].url;
							}else{
								img = JSON.parse(this.detail.coverAddress).link;
							}
							this.detail.imgUrl = img;
							if(this.detail.courseContent.length > 0){
								for (let i = 0; i < this.detail.courseContent.length; i++) {
									if(this.detail.courseContent[i].type == '视频资源'){
										this.videoList = this.detail.courseContent[i];
									}
									if(this.detail.courseContent[i].type == '音频资源'){
										this.audioList = this.detail.courseContent[i];
									}
									if(this.detail.courseContent[i].type == '图文资源'){
										this.imageList = this.detail.courseContent[i];
									}
									if(this.detail.courseContent[i].type == '文档资源'){
										this.textList = this.detail.courseContent[i];
									}
								}
							}
						} else {
							this.$message({
								message: res.msg,
							});
						}
					})
			},
			addClass(){
				if(this.detail.isPurchase == 0){
					return;
				}
				if(!this.hasLogin){
					return this.$message('请先进行登录！');
				}
				this.$confirm('是否确定加入我的课程?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					let obj = {
						belongType: this.type == '1' ? '0' : '1',
						classObjectCourseId: this.id,
						userId: this.userInfo.user_id
					}
					this.$post('/user/BladeUserCourseSelection/user-add-class',obj)
						.then(res => {
							console.log('添加课程',res)
							if(res.code == 200){
								this.$message({
								  message: '添加课程成功',
								  type: 'success'
								});
								this.detail.isPurchase = 0;
								this.getBtnLeft()
							}
							
						})
						
				}).catch(() => {
					
				});
			},
			getBtnLeft(state,data){
				this.$get('/personal-center/v1/personal-subject/credit_hour',{year:''})
					.then(res => {
						if(res.code == '200'){
						 	let leftForm = {
								selecteHours1:res.data.selectedCommonCurseHours?res.data.selectedCommonCurseHours:0,//已选共需课程学时
								selecteHours2:res.data.selectedProfessionCurseHours?res.data.selectedProfessionCurseHours:0,// 已选专业课程学时
								publicCredit:res.data.publicCredit?res.data.publicCredit:0,//公需学分
								professionalCredit:res.data.professionalCredit?res.data.professionalCredit:0//专业学分
							}
							this.$store.dispatch('getBtnLeft',leftForm)
						}else{
							this.$message({
								message: res.msg,
							});
						}
					})
			},
			//下载课件
			goDownload(obj){
				if(!this.hasLogin){
					return this.$message('请先进行登录！');
				}
				// 先请求后台判断是否可以观看视频
				this.$get('/blade-system/user/canWatchVideo', { courseId: this.id })
					.then(res => {
						if(res && (res.code === 200 || res.code === '200')){
							if(res.success === false || res.data === false){
								this.$alert(res.msg || '无法观看该视频', '课程提示', {
									confirmButtonText: '确定',
								});
								return;
							}
							let url = '';
							if(this.type == '1'){
								url = obj.fileUrl;
							}else{
								url = JSON.parse(obj.coverAddress).link;
							}
							var iframe = document.createElement('iframe');
							iframe.style.display = 'none';
							iframe.src = "javascript: '<script>location.href=\"" + url + "\"<\/script>'";
							document.getElementsByTagName('body')[0].appendChild(iframe);
						} else {
							this.$alert(res.msg || '请求失败', '课程提示', {
								confirmButtonText: '确定',
							});
						}
					})
					.catch(err => {
						console.error('canWatchVideo error', err);
						this.$alert('请求出错', '课程提示', {
							confirmButtonText: '确定',
						});
					});
			},
			goBoFang(e,sourcetype){
				if(!this.hasLogin){
					return this.$message('请先进行登录！');
				}
				if(this.detail.isPurchase != 0){
					return this.$message('请先完成选课！');
				}
				// 先请求后台判断是否可以观看视频
				this.$get('/blade-system/user/canWatchVideo', { courseId: this.id })
					.then(res => {
						if(res && (res.code === 200 || res.code === '200')){
							if(res.success === false || res.data === false){
								this.$alert(res.msg || '无法观看该视频', '课程提示', {
									confirmButtonText: '确定',
								});
								return;
							}
							// 允许观看，打开播放页面
							let routeUrl = this.$router.resolve({
								path: "/VideoPlayback/VideoPlayback",
								query: { id: e.id ? e.id : e.gsrId,detailId: this.id,type: this.type,sourcetype: sourcetype }
							});
							window.location.assign(routeUrl.href);
						} else {
							this.$alert(res.msg || '请求失败', '课程提示', {
								confirmButtonText: '确定',
							});
						}
					})
					.catch(err => {
						console.error('canWatchVideo error', err);
						this.$alert('请求出错', '课程提示', {
							confirmButtonText: '确定',
						});
					});
			},
			getTime(num){
				let hour = parseInt(num / 3600);
				let minu = parseInt(num % 3600 / 60);
				let seco = parseInt(num % 60);
				
				if(hour < 10){
					hour = '0' + hour;
				}
				if(minu < 10){
					minu = '0' + minu;
				}
				if(seco < 10){
					seco = '0' + seco;
				}
				return hour + ':' + minu + ':' + seco;
			},
			getResourceDuration(item){
				if(!item){
					return 0;
				}
				return Number(this.type == '1' ? item.duration : item.resourceTimeLength) || 0;
			},
			getWatchProgress(item){
				const total = this.getResourceDuration(item);
				const watched = Number(item && item.lastPlaybackPosition) || 0;
				if(total <= 0){
					return 0;
				}
				const percent = (watched / total) * 100;
				return Math.min(100, Math.max(0, Math.round(percent)));
			},
			chooseTeacher(obj){
				this.teacher = obj;
			}
		}
	};
</script>

<style scoped lang="less">
	::-webkit-scrollbar {
		width: 2px;
		height: 4px;
	}
	
	/*  滚动条轨道 */
	::-webkit-scrollbar-track {
		background-color: rgba(30, 53, 81, 0.4);
	}
	
	/*  滚动条上的滚动滑块 */
	::-webkit-scrollbar-thumb {
		background-color: rgba(211, 211, 211, 0.7);
		border-radius: 4px;
	}
	.content{
		background-color: #EBEFF1;padding-bottom: 0.3rem;
	}
	.title{
		width: 12rem;height: 0.6rem;color: #000000;font-size: 0.15rem;font-weight: 400;font-family: Alibaba PuHuiTi;
		display: flex;align-items: center;
		margin-left: 3.6rem;
	}
	.title span:first-child{
		color: #cccccc;
	}
	.content_con{
		width: 11.4rem;background: #FFF;padding: 0.3rem;margin:0 auto;
		.title_kcjs{
			color: #000000;font-family: Alibaba PuHuiTi;font-size: 0.20rem;font-weight: 700;margin-bottom: 0.3rem;
		}
		.con_kcjs{
			display: flex;align-items: center;width: 100%;margin-bottom: 0.4rem;
			.con_kcjs_img{
				width: 4.68rem;height: 2.64rem;margin-right: 0.3rem;
			}
			.con_kcjs_title{
				color: #000000;font-family: Alibaba PuHuiTi;font-size: 0.24rem;margin-bottom: 0.2rem;
				overflow: hidden;text-overflow: ellipsis;
			}
			.con_kcjs_div{
				color: #000000;font-family: Alibaba PuHuiTi;font-size: 0.16rem;margin-bottom: 0.2rem;font-weight: 400;
				.con_kcjs_price{
					color: #f43786;
				}
			}
			.con_kcjs_btn{
				width: 1.22rem;height: 0.38rem;border-radius: 0.04rem;background: #134F97;color: #ffffff;font-family: Alibaba PuHuiTi;
				font-size: 0.16rem;font-weight: 400;display: flex;align-items: center;justify-content: center;cursor: pointer;
			}
		}
		.title_ztjs{
			color: #000000;font-family: Alibaba PuHuiTi;font-size: 0.20rem;font-weight: 700;margin-bottom: 0.2rem;
		}
		.con_ztjs{
			color: #000000;font-family: Alibaba PuHuiTi;font-size: 0.16rem;font-weight: 400;margin-bottom: 0.38rem;text-indent: 2em;
		}
		.con_lsjs{
			width: 11rem;height: 1.08rem;border-radius: 0.04rem;background: #134f971a;padding: 0.2rem;display: flex;align-items: center;
			.con_lsjs_left{
				color: #000000;font-family: Alibaba PuHuiTi;font-size: 0.16rem;font-weight: 700;margin: 0 0 0 0.4rem;text-align: center;
				.con_lsjs_img{
					width: 0.73rem;height: 0.73rem;margin-bottom: 0.08rem;
				}
				.con_lsjs_text_act{
					 color: #117cca;
				}
			}
			.con_lsjs_line{
				width: 1px;height: 100%;background: rgba(19, 79, 151, 0.2);
			}
			.con_lsjs_right{
				width: 5.15rem;
				color: #000000;font-family: Alibaba PuHuiTi;font-size: 0.16rem;font-weight: 400;margin-left: 0.4rem;text-indent: 2em;
			}
		}
		.title_ztnr{
			color: #000000;font-family: Alibaba PuHuiTi;font-size: 0.20rem;font-weight: 700;margin-bottom: 0.3rem;margin-top: 0.4rem;
		}
		.div_kcbiaoti{
			width: 11.40rem;height: 0.87rem;background: rgba(19, 79, 151, 0.05);display: flex;align-items: center;margin-bottom: 0.3rem;
			.num_kcbiaoti{
				width: 0.41rem;height: 0.41rem;border-radius: 50%;border:0.02rem solid rgba(19, 79, 151, 0.3);color: rgb(17, 124, 202);text-align: center;
				font-family: Alibaba PuHuiTi;font-size: 0.24rem;font-weight: 700;display: flex;align-items: center;justify-content: center;margin-left: 0.68rem;margin-right: 0.12rem;
			}
			.text_kcbiaoti{
				color: #000000;font-family: Alibaba PuHuiTi;font-size: 0.2rem;font-weight: 700;
				.text_span{
					font-size: 0.15rem;
				}
			}
		}
		.div_kcbiaoti_margin{
			margin-top: 0.3rem;
		}
		.con_kc{
			display: flex;align-items: center;justify-content: space-between;
			.con_kc_left{
				display: flex;align-items: center;margin-left: 0.73rem;
				.con_kc_img{
					width: 0.32rem;height: 0.32rem;margin-right: 0.16rem;
				}
				.con_kc_zj{
					color: #000000;font-family: Alibaba PuHuiTi;font-size: 0.16rem;
				}
				.con_kc_sc{
					color: rgb(204, 204, 204);font-family: Alibaba PuHuiTi;font-size: 0.16rem;
				}
				.con_kc_progress{
					display: flex;align-items: center;margin-top: 0.06rem;
					.con_kc_progress_track{
						width: 2.4rem;height: 0.06rem;background: rgba(19, 79, 151, 0.1);border-radius: 0.04rem;overflow: hidden;
					}
					.con_kc_progress_bar{
						height: 100%;background: #134F97;border-radius: 0.04rem;
					}
					.con_kc_progress_text{
						color: rgb(204, 204, 204);font-family: Alibaba PuHuiTi;font-size: 0.14rem;margin-left: 0.1rem;white-space: nowrap;
					}
				}
			}
			.con_kc_btn{
				width: 1.02rem;height: 0.32rem;border-radius: 0.04rem;border: 1px solid #134F97;font-family: Alibaba PuHuiTi;
				font-size: 0.14rem;color: #134F97;display: flex;align-items: center;justify-content: center;margin-right: 3.36rem;cursor: pointer;
			}
		}
		.con_kc_line{
			width: 1px;height: 0.30rem;background: rgba(19, 79, 151, 0.3);margin-left: 0.88rem;
		}
	}
</style>



// WEBPACK FOOTER //
// src/index/videoDetail.vue